import { ReactNode } from "react";

import classNames from "classnames";

import { ComponentItemProps as ExternalComponentItemProps } from "../ComponentItem";

import styles from "../styles.module.css";

/** The `ComponentItem` component properties. */
export interface ComponentItemProps extends ExternalComponentItemProps {
  /**
   * The aria-label for the menu link item element.
   */
  readonly "aria-label"?: string;

  /**
   * The unique id for the menu item element.
  */
  readonly id?: string;
}

/** The renderable menu item. */
export const ComponentItem = (props: ComponentItemProps): ReactNode => {
  const { className, style, children, disabled = false, "aria-label": ariaLabel, id } = props;
  const itemId = id || `menuitemid`;

  return (
    <button
      type="button"
      id={itemId}
      disabled={disabled}
      role="menuitem"
      aria-label={ariaLabel ?? (typeof children === "string" ? children : undefined)}
      tabIndex={disabled ? -1 : 0}
      className={classNames(styles.ComponentItem, "component-item", className, "option", "content")}
      style={style}
    >
      {children}
    </button>
  );
};
